import { Pagination, Button } from "@mui/material";
import styled from "styled-components";

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  // The default Previous/Next buttons are styled by targeting their types:
  '& .MuiPaginationItem-previousNext, & .MuiPaginationItem-root': {
    fontSize: '1rem',
    margin: '0 4px', // Add some space between items
    // Remove the default hover background for 'Prev' and 'Next' 
    // to match the light appearance in the image.
    '&[aria-label="Go to previous page"], &[aria-label="Go to next page"]': {
        color: theme.palette.text.secondary, // Gray text for Prev/Next
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent', // No hover effect for text buttons
        }
    },
  },
  
  // Customizing the appearance of the selected page button (the green '1'):
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: '#528B8B', // A greenish-teal color to match the image
    color: '#fff', // White text
    borderRadius: '4px', // Slightly rounded corners
    // Ensure the selected item remains the custom color on hover/focus
    '&:hover': {
      backgroundColor: '#528B8B',
    },
  },
}));

export const PaginationButton = styled(Button)(({ theme }) => ({
  textTransform: 'capitalize',
}));